import {
    GET_PRODUCTS, GET_RISK_TYPE, VALIDATE_PROMO, GET_RISK_PROFILER_INFO, GET_DEFAULT_RISK_PROFILER, SAVE_RISK_PROFILER_INFO, GENERATE_PAYU_HASH, CREATE_PAYMENT_REQUEST, PROCESS_PAYMENT_REQUEST, UPDATE_PAYMENT_REQUEST, SEND_INITIAL_SUBSCRIPTION_MAIL, SEND_RISK_PROFILER_MAIL_NOTIFICATION, GET_USER_SUBSCRIPTION, CHECK_USER_CKYC,GET_LEGAL_AGREEMENT,
	SAVE_LEGAL_AGREEMENT, GET_USER_INFO,CREATE_RZP_PAYMENT_REQUEST
} from '@/store/actions.type';
import { mapActions } from 'vuex';
import moment from 'moment';
import alertModel from '../../components/Dialogs/riskProfilerConfirmationPopup';
// import ckycmodal from './../../components/Dialogs/CKYCModal.vue'
import { email } from 'vuelidate/lib/validators';
import { data } from 'jquery';
import disclaimer from './../../components/Disclaimer.vue';
import axios from 'axios';
import KycReminderPopup from'../../components/KycReminderPopup.vue';



export default {
    components: { alertModel, disclaimer, KycReminderPopup },
    data () {
        return {
            productsLoading: true,
            // riskProfilerLoading: true,
            planId:this.$route.query.utm_plan,
            // riskTypeLoading: true,
            // defaultRiskProfilerLoading: true,
            // showPlanDetails: localStorage.getItem('callRiskProfiler')=="true"?false:true,
            // showRiskProfile: localStorage.getItem('callRiskProfiler')=="true"?true:false,
            showPlanDetails: true,
            selectedProduct: {},
            selectedProductId: null,
            promoId: 0,
            promoText: this.$route.query.promo,
            promoStatus: false,
            promoStatusText: '',
            // riskType: '',
            modalShow: true,
            gstin: '',
            riskInfo: {
            },
            // riskanswers: {
            //     q1Ans: "",
            //     q2Ans: "",
            //     q3Ans: ""
            // },
            paymentReqPayload: {
                'productId': '',
                'deviceId': '',
                'amount': '',
                'gatewayId': ''
            },
            hashPayload: {
                'type': '',
                'txnid': '',
                'amount': '',
                'firstname': '',
                'email': '',
                'productinfo': 'PortfolioSmithIndia'
            },
            paymentRequest: {
                'reqId': '',
                'amount': '',
                'txnid': '',
                'hash': '',
                'firstname': '',
                'email': '',
                'phone': '',
                'productinfo': 'PortfolioSmithIndia',
                'key': '7JZRyjP9',
                'surl': 'https://portfoliosmith.in/paymentsuccess',
                'furl': 'https://portfoliosmith.in/paymentfailure'
            },
            cancelPaymentReqPayload: {
                'reqId': '',
                'satatus': ''
            },
            subscriptionPayload: {
                'reqId': '',
                'amount': '',
                'status': '',
                'merchantTranId': '',
                'firstname': '',
                'email': '',
                'phone': '',
                'productinfo': 'PortfolioSmithIndia',
                'subType': '',
                'scid': '',
                'modeOfPayment': '',
                'transactionId': '',
                'amount': '',
                'receipt': '',
                'receiptType': '',
                'receiptVerification': '',
            },
            termsChecked: 0,
            promoAdded: false,
            promoTextAdded: false,
            enableInput: false,
            showAlert: false,
            ignoreAggressiveRiskProfile:false,
            isCKYCDone: false,
            isPremiumUser: false,
            isRazorPayActive: true,
            rzpPymentRequest: {
				"key": "rzp_live_OLoNBB4IJ40p1P",
				"currency": "INR",
				"description": "PortfolioSmith Report Payment",
                "image": "https://storage.googleapis.com/mscharts/portfoliosmith/portfoliosmithLogo.svg",
				"prefill": {

				},
				"notes": {
                "address": "Akshay Tech Park, EPIP Area, Whitefield, Bangalore 560048"
                        },
                "theme": {
                    "color": "#0F4C99"
                        },
				"modal": {
					"backdropclose": false,
					"escape": false,
					"handleback": true,
					"confirm_close": true,
					"animation": true
				},
				"retry": {
					"enabled": true,
					"max_count": 1
				}
			},
            rzpSubscriptionPayload: {
				'reqId': '',
				'status': '',
				'orderId': '',
                'subType': '',
				'paymentId': '',
				'signature': '',
                'amount': ''
			},


        }
    },

    created () {

        window.scrollTo(0, 0);
        this.checkauth();
		this.checkIfARUser();
        // this.loadData();
        this.fetchproducts();
        // this.getActiveLegalAgreement("PSI",localStorage.getItem("uid"));
    },

    computed: {
        productsInfo () {
            var products = this.$store.state.home.products;

            return products;
        },

        // riskProfiler () {
        //     var riskProfiler = this.$store.state.home.riskprofilerinfo;

        //     return riskProfiler;
        // },

        smallcasedetails () {
            return this.$store.state.smallcase.smallcasedetail;
        },

        isBrokerUser () {
            return this.$store.state.authentication.user.isBrokerUser;
        },
        userData () {
            return this.$store.state.authentication.user;
          },
    },

    methods: {
        ...mapActions({
            getproducts: GET_PRODUCTS,
            // getrisktype: GET_RISK_TYPE,
			validatepromo: VALIDATE_PROMO,
            // getriskprofilerinfo: GET_RISK_PROFILER_INFO,
            // getdefaultriskprofiler: GET_DEFAULT_RISK_PROFILER,
            // saveriskporfilerinfo: SAVE_RISK_PROFILER_INFO,
			generatepayuhash: GENERATE_PAYU_HASH,
            createpaymentrequest: CREATE_PAYMENT_REQUEST,
            processpaymentrequest: PROCESS_PAYMENT_REQUEST,
            updatepaymentrequest: UPDATE_PAYMENT_REQUEST,
            sendinitialsubscriptionmail: SEND_INITIAL_SUBSCRIPTION_MAIL,
            // sendRiskProfilerMailNotification:SEND_RISK_PROFILER_MAIL_NOTIFICATION,
            getusersubscription: GET_USER_SUBSCRIPTION,
            checkuserckyc: CHECK_USER_CKYC,
            getactivelegal: GET_LEGAL_AGREEMENT,
			savelegalagreement: SAVE_LEGAL_AGREEMENT,
            getIsCkyc: GET_USER_INFO,
            createrzppaymentrequest: CREATE_RZP_PAYMENT_REQUEST
        }),
		// popUpMsg() {
        //     this.showAlert = true;
        //     this.message = 'The selected Risk Profile is not suitable for Equity investing as it involves risk.Do you still want to continue?';
        // },
        // cancelModal() {
        //     this.showAlert = false;
        //     this.ignoreAggressiveRiskProfile=false;
        // },
        // changeAggressiveRiskProfile(){
        //     this.ignoreAggressiveRiskProfile=this.ignoreAggressiveRiskProfile==false?true:false;
        // },
        allowAction(){
            this.showAlert = false;
            this.displayPlanDetails();
            // this.ignoreAggressiveRiskProfile=false;
        },
		async checkIfARUser () {
			if(this.isBrokerUser)
				this.$router.push("/plandetailsnew/");
		},

        // async loadData () {
        //     await this.getRiskProfilerInfo();
        // },
        // async getActiveLegalAgreement (productCode,userId) {
		//     var payload = {
		// 		userId:userId,
        //         productCode: productCode
        //     };
		// 	await this.getactivelegal(payload).then(result => {
		// 		if(result!=null){
		// 			this.saveLegalAgreement(result.id)
		// 		}

		// 	});
		// },

        // async saveLegalAgreement(legalAgreementId) {
        //     var self = this;
        //     var payload = {
        //         userId:localStorage.getItem("uid"),
        //         legalAgreementId:legalAgreementId,
        //         isAccepted:1
        //     };
        //     await this.savelegalagreement(payload).then(result => {
        //         if(result!=null){
        //         }

        //     });
        // },

        async fetchproducts () {
            var self = this;
			var durationDays = 0;

            this.productsLoading = false;
            await this.getproducts().then(data => {
                data.forEach(function (item, index) {
                    if (item.defaultOfferPerc && item.defaultOfferPerc != 0) {
                        item.finalAmount = item.amount - ((item.amount * item.defaultOfferPerc) / 100).toFixed(0);
                        item.discount = item.defaultOfferPerc;
                        item.discountAmount = item.amount - item.finalAmount;
                    } else {
                        item.finalAmount = item.amount;
                        item.discount = 0;
                        item.discountAmount = 0;
                    }
                    item.product = item.description;

					if(index == 0){
						durationDays = item.durationDays;
						self.selectedProductId = item.id;
                        self.selectedProduct = {};
                        Object.assign(self.selectedProduct, item);
					} else{
						if(item.durationDays > durationDays){
							durationDays = item.durationDays;
							self.selectedProductId = item.id;
							self.selectedProduct = {};
							Object.assign(self.selectedProduct, item);
						}
					}
                });
                if (self.promoText != null && self.promoText != '') {
                    self.validatePromoCode();
                }
            });

            if(this.planId == 'Monthly'){
                this.onProductChange (1)
             }else if(this.planId == 'Quarterly'){
                this.onProductChange (2)
             }else{
                this.onProductChange (3)
             }

            this.productsLoading = true;
        },

        // async getRiskProfilerInfo () {
        //     var self = this;
        //     this.riskProfilerLoading = false;
        //     await this.getriskprofilerinfo().then(data => {
        //         self.riskanswers = data.riskAnswers;
        //         self.riskType = data.riskInfo.riskType;
        //         self.gstin = data.riskInfo.gstin ? data.riskInfo.gstin : '';
        //         self.riskInfo.gstin = data.riskInfo.gstin;
        //         self.riskInfo.riskType = data.riskInfo.riskType;
        //         self.riskInfo.state = data.riskInfo.state;
        //     });
        //     this.riskProfilerLoading = true;

        // },

        onProductChange (productId) {
            this.selectedProductId = productId;
            this.selectedProduct = {};
            Object.assign(this.selectedProduct, this.getProductById(productId));
            this.promoId = 0;
            if (this.$route.query.promo && this.promoText != null && this.promoText != '') {
                this.validatePromoCode();
            }
            else {
                this.promoText = '';
            }
            this.promoStatus = false;
            this.promoStatusText = "";
        },

        // async onRiskProfilerAnsChange (event, qno) {
        //     switch (qno) {
        //         case 1: this.riskanswers.q1Ans = event.target.value;
        //             break;
        //         case 2: this.riskanswers.q2Ans = event.target.value;
        //             break;
        //         case 3: this.riskanswers.q3Ans = event.target.value;
        //             break;
        //         case 4: this.riskanswers.q4Ans = event.target.value;
        //             break;
        //         case 5: this.riskanswers.q5Ans = event.target.value;
        //             break;
        //         case 6: this.riskanswers.q6Ans = event.target.value;
        //             break;
        //         case 7: this.riskanswers.q7Ans = event.target.value;
        //             break;
        //         case 8: this.riskanswers.q8Ans = event.target.value;
        //             break;
        //         case 9: this.riskanswers.q9Ans = event.target.value;
        //             break;
        //         case 10: this.riskanswers.q10Ans = event.target.value;
        //             break;
        //         case 11: this.riskanswers.q11Ans = event.target.value;
        //             break;
        //         case 12: this.riskanswers.q12Ans = event.target.value;
        //             break;
        //         case 13: this.riskanswers.q13Ans = event.target.value;
        //             break;
        //         case 14: this.riskanswers.q14Ans = event.target.value;
        //             break;
        //         case 15: this.riskanswers.q15Ans = event.target.value;
        //             break;
        //     }

        //     await this.setRiskType();
        // },

        // async setRiskType () {
        //     var self = this;
        //     var totalScore = 0;
        //     Object.keys(self.riskanswers).forEach(function (key) {
        //         totalScore = totalScore + self.getRiskScore(self.riskanswers[key]);
        //     });

        //     this.riskanswers.totalScore = totalScore;
        //     this.riskTypeLoading = false;
        //     await this.getrisktype(totalScore).then(data => {
        //         self.riskType = data.riskType;
        //     });
        //     this.riskTypeLoading = true;
        // },

        // getRiskScore (riskAns) {
        //     if (riskAns == 'A')
        //         return 1;
        //     else if (riskAns == 'B')
        //         return 2;
        //     else if (riskAns == 'C')
        //         return 3;
        //     else if (riskAns == 'D')
        //         return 4;
        //     else
        //         return 0;
        // },

        // async setDefaultRiskProfiler () {
        //     var self = this;
        //     this.defaultRiskProfilerLoading = false;
        //     await this.getdefaultriskprofiler().then(data => {
        //         self.riskanswers = data;
        //         self.riskType = 'Aggressive';
        //     });
        //     this.defaultRiskProfilerLoading = true;
        //     if (this.termsChecked == 1) {
        //         this.displayPlanDetails();
        //     }
        //     else {
        //         self.$dialog.alert('Accept terms and Conditions');

        //     }

        // },

        removePromoCode () {
            this.promoId = 0;
            this.promoText = "";
            this.promoStatus = false;
            this.promoStatusText = "";
            this.selectedProduct = {};
            Object.assign(this.selectedProduct, this.getProductById(this.selectedProductId));
            this.promoAdded = false;
        },

        onEnterPromo (event) {
            if (typeof event == "string" && event.length > 0) {
                this.promoTextAdded = true;
            }
            else {
                this.promoTextAdded = false;
            }
            if (!this.promoAdded) {
                this.promoStatusText = '';
            }
        },

        updatePromoAdded () {
            this.promoAdded = false;
            this.promoTextAdded = false;
            Object.assign(this.selectedProduct, this.getProductById(this.selectedProductId));
            this.promoStatus = false;
            this.promoStatusText = '';
        },

        async validatePromoCode () {
            var self = this;

            if (!this.promoText) {
                this.promoId = 0;
                this.promoStatusText = 'Please Enter Promo Code';
                self.selectedProduct.product = self.selectedProduct.description;
                self.selectedProduct.discount = 0;
                self.selectedProduct.discountAmount = 0;
                self.selectedProduct.finalAmount = self.getProductById(self.selectedProductId).amount;
            } else {
                var payload = {
                    productId: this.selectedProductId,
                    promoCode: this.promoText,
                    userTypeId:this.userData.userType == 3 ? 2 : this.userData.userType
                };

                await this.validatepromo(payload).then(data => {
                    if (data != null) {
                        self.promoId = data.promoId;
                        self.promoStatus = data.success;
                        self.promoStatusText = data.message;
                        if (data.success) {
                            if (data.product)
                                self.selectedProduct.product = data.product;
                            self.selectedProduct.discount = data.percentage;
                            self.selectedProduct.discountAmount = (self.selectedProduct.amount * data.percentage / 100).toFixed(2);
                            self.selectedProduct.finalAmount = (self.selectedProduct.amount - ((self.selectedProduct.amount * data.percentage / 100)).toFixed(2));
                            self.promoAdded = true;
                        } else {
                            self.selectedProduct.product = self.selectedProduct.description;
                            self.selectedProduct.discount = 0;
                            self.selectedProduct.discountAmount = 0;
                            self.selectedProduct.finalAmount = self.getProductById(self.selectedProductId).amount;
                        }
                    } else {
                        self.promoId = 0;
                        self.promoStatus = false;
                        self.promoStatusText = 'Invalid Promo Code!';
                        self.selectedProduct.product = self.selectedProduct.description;
                        self.selectedProduct.discount = 0;
                        self.selectedProduct.discountAmount = 0;
                        self.selectedProduct.finalAmount = self.getProductById(self.selectedProductId).amount;
                    }
                });
            }
        },

        getProductById (productId) {
            var products = this.$store.state.home.products;
            var product = null;
            product = products.filter(item => item.id == productId);

            return product[0];
        },

        onStateChange (event) {
            if (event.target.options.selectedIndex > -1) {
                this.riskInfo.state = event.target.options[event.target.options.selectedIndex].value;
            }
        },

        // displayPlanDetails () {
        //     if(this.riskType=="Aggressive" || this.ignoreAggressiveRiskProfile==true)
        //     {
        //         this.showPlanDetails = true;
        //         this.showRiskProfile = false;
        //         this.sendRiskProfilerMail(this.riskanswers);
        //         if(localStorage.getItem("callRiskProfiler")=="true")
        //         {
        //             localStorage.removeItem('callRiskProfiler');
        //             this.$router.push('/evaluation');
        //         }
        //     }
        //     else{
        //         this.popUpMsg();
        //     }

        // },

        // async sendRiskProfilerMail(riskAnswers){
        //     var riskAnswersPayload={};
        //     riskAnswersPayload.emailId=this.$store.state.authentication.user.email;
        //     riskAnswersPayload.riskType=this.riskType
        //     riskAnswers.q1Ans=="A"?riskAnswersPayload.q1Ans="Dependent on other's income":riskAnswers.q1Ans=="B"?riskAnswersPayload.q1Ans="Salary":riskAnswers.q1Ans=="C"?riskAnswersPayload.q1Ans="Professional Income":riskAnswersPayload.q1Ans="Business";
        //     riskAnswers.q2Ans=="A"?riskAnswersPayload.q2Ans="Under Rs. 5,00,000":riskAnswers.q2Ans=="B"?riskAnswersPayload.q2Ans="Rs. 5,00,000 to Rs. 10,00,000":riskAnswers.q2Ans=="C"?riskAnswersPayload.q2Ans="Rs. 10,00,000 to Rs. 20,00,000":riskAnswersPayload.q2Ans="Over Rs. 20,00,000";
        //     riskAnswers.q3Ans=="A"?riskAnswersPayload.q3Ans="Retired. Will rely on invested funds to maintain lifestyle":riskAnswers.q3Ans=="B"?riskAnswersPayload.q3Ans="One or more children, wanting to invest to secure their future needs":riskAnswers.q3Ans=="C"?riskAnswersPayload.q3Ans="Want to start my retirement planning. Very few family financial burden":riskAnswersPayload.q3Ans="Single with no financial burden. Investing for long term goals";
        //     riskAnswers.q4Ans=="A"?riskAnswersPayload.q4Ans="Retirement plans":riskAnswers.q4Ans=="B"?riskAnswersPayload.q4Ans="Hedging":riskAnswers.q4Ans=="C"?riskAnswersPayload.q4Ans="Long term capital appreciation":riskAnswersPayload.q4Ans="Short term capital appreciation";
        //     riskAnswers.q5Ans=="A"?riskAnswersPayload.q5Ans="Very little understanding":riskAnswers.q5Ans=="B"?riskAnswersPayload.q5Ans="I have basic understanding of investing. I understand the risks and basic investment concept like diversification":riskAnswers.q5Ans=="C"?riskAnswersPayload.q5Ans="I understand how market fluctuates and the pros and cons of investing in it":riskAnswersPayload.q5Ans="I am an experienced investor/trader";
        //     riskAnswers.q6Ans=="A"?riskAnswersPayload.q6Ans="Book your loss and invest in fixed deposits or bonds":riskAnswers.q6Ans=="B"?riskAnswersPayload.q6Ans="Hold on till that stock comes back and gives an alternative":riskAnswers.q6Ans=="C"?riskAnswersPayload.q6Ans="Do not bother because you had done enough research on the company":riskAnswersPayload.q6Ans="Average your cost by investing more at a lower price";
        //     riskAnswers.q7Ans=="A"?riskAnswersPayload.q7Ans="Sell":riskAnswers.q7Ans=="B"?riskAnswersPayload.q7Ans="Wait and watch":riskAnswers.q7Ans=="C"?riskAnswersPayload.q7Ans="See your cash flow at the end of the year and buy more if the prices of these shares are still low":riskAnswersPayload.q7Ans="Average your cost by buying more";
        //     riskAnswers.q8Ans=="A"?riskAnswersPayload.q8Ans="I don't know what inflation is":riskAnswers.q8Ans=="B"?riskAnswersPayload.q8Ans="Inflation may erode my savings but I have no tolerance for loss":riskAnswers.q8Ans=="C"?riskAnswersPayload.q8Ans="I am conscious of the risks inflation presents, but would prefer a middle ground":riskAnswersPayload.q8Ans="I am comfortable with this trade off to beat inflation";
        //     riskAnswers.q9Ans=="A"?riskAnswersPayload.q9Ans="Stable return, minimal tax saving":riskAnswers.q9Ans=="B"?riskAnswersPayload.q9Ans="Guaranteed return before tax saving":riskAnswers.q9Ans=="C"?riskAnswersPayload.q9Ans="Some variability in returns will do, reasonable tax saving":riskAnswersPayload.q9Ans="Very high returns, irrespective of tax saving";
        //     riskAnswers.q10Ans=="A"?riskAnswersPayload.q10Ans="Cut losses immediately and liquidate all investment. Capital preservation is paramount":riskAnswers.q10Ans=="B"?riskAnswersPayload.q10Ans="You would be worried, but would give your investment a little more time":riskAnswers.q10Ans=="C"?riskAnswersPayload.q10Ans="You are comfortable with volatility and accept decline in portfolio value as a part of investing.":riskAnswersPayload.q10Ans="You would add to your investments to bring the average buying price lower";
        //     riskAnswers.q11Ans=="A"?riskAnswersPayload.q11Ans="Average Year 5%":riskAnswers.q11Ans=="B"?riskAnswersPayload.q11Ans="Average Year 12%":riskAnswers.q11Ans=="C"?riskAnswersPayload.q11Ans="Average Year 13%":riskAnswersPayload.q11Ans="Average Year 14%";
        //     riskAnswers.q12Ans=="A"?riskAnswersPayload.q12Ans="Disagree":riskAnswers.q12Ans=="B"?riskAnswersPayload.q12Ans="Neutral":riskAnswers.q12Ans=="C"?riskAnswersPayload.q12Ans="Agree":riskAnswersPayload.q12Ans="Strongly agree";
        //     riskAnswers.q13Ans=="A"?riskAnswersPayload.q13Ans="Have not been trading in equity market. I am starting my stock market investment with ArgoSmith":riskAnswers.q13Ans=="B"?riskAnswersPayload.q13Ans="Have been trading in equity market and have already started my derivatives trading":riskAnswers.q13Ans=="C"?riskAnswersPayload.q13Ans="Very experienced ' have been investing in equity &amp; derivative markets for the last 3-5 years":riskAnswersPayload.q13Ans="Very experienced ' have been investing in equity &amp; derivative markets for more than 5 years";
        //     riskAnswers.q14Ans=="A"?riskAnswersPayload.q14Ans="Between  0% and 10%":riskAnswers.q14Ans=="B"?riskAnswersPayload.q14Ans="Between  10% and 25%":riskAnswers.q14Ans=="C"?riskAnswersPayload.q14Ans="Between  25% and 50%":riskAnswersPayload.q14Ans="Over 50%";
        //     riskAnswers.q15Ans=="A"?riskAnswersPayload.q15Ans="For 10+ years":riskAnswers.q15Ans=="B"?riskAnswersPayload.q15Ans="For 6 - 10 years":riskAnswers.q15Ans=="C"?riskAnswersPayload.q15Ans="For 3 - 5 years":riskAnswersPayload.q15Ans="For 2 years or less";

        //    this.saveRiskPorfiler();
        //    await this.sendRiskProfilerMailNotification(riskAnswersPayload).then(data =>{
        //     if(data.success==true)
        //     else
        //     self.$dialog.alert(data.message);
        //    });


        // },

        // displayRiskProfile () {
        //     this.showPlanDetails = false;
        //     this.showRiskProfile = true;
        // },

        async onClickOfPaySecure () {
            if (this.gstin != null && this.gstin.trim() != '') {
                let isGSTINValid = this.validateGSTN(this.gstin.trim())
                if (!isGSTINValid) {
                    return
                }
            }
                this.checkCkycPaySecure()
                    // if (this.isCKYCDone) {
                    // }
                    // else if (!this.isBrokerUser) {
                    //     const userId = this.$store.state.authentication.user.id
                    //     const emailId = this.$store.state.authentication.user.email
                    //     const safeUrl = encodeURIComponent(window.location.href);
                    //     const href = `https://ckycui-dot-qsi-gcloud-prod.el.r.appspot.com/ckycui/?uid=${userId}&prod=PSI&email=${emailId}&url=${safeUrl}`;
                    //     window.location.href = href;                        
                    // }
                
        },

        // async saveRiskPorfiler () {
        //     var data = {};
        //     Object.assign(data, this.riskanswers);
        //     data.state = (this.riskInfo.state=="null" || this.riskInfo.state==null)?"Karnataka":this.riskInfo.state;
        //     data.gstin = this.gstin != null ? this.gstin.toUpperCase() : null;
        //     data.riskType = this.riskType;

        //     await this.saveriskporfilerinfo(data).then(result => {
        //     });
        // },

		async createPaymentRequest () {
            var self = this;
            var user = this.$store.state.authentication.user;
            self.paymentReqPayload.productId = self.selectedProduct.id;
            self.paymentReqPayload.deviceId = 1;
            self.paymentReqPayload.amount = self.selectedProduct.finalAmount;
            self.paymentReqPayload.gatewayId = 1;
            self.paymentReqPayload.promoId = self.promoId != 0 ? self.promoId : '';

            self.hashPayload.type = "request";
            self.hashPayload.amount = self.selectedProduct.finalAmount;
            self.hashPayload.firstname = user.name.split(' ')[0];
            self.hashPayload.email = user.email;

            self.paymentRequest.amount = self.selectedProduct.finalAmount;
            self.paymentRequest.firstname = user.name.split(' ')[0];
            self.paymentRequest.email = user.email;
            self.paymentRequest.phone = user.phoneNumber;
            await this.createpaymentrequest(self.paymentReqPayload).then(data => {
                self.paymentRequest.reqId = data.reqId;
                self.hashPayload.txnid = data.merchantTranId;
                self.paymentRequest.txnid = data.merchantTranId;
                this.generatepayuhash(self.hashPayload).then(hash => {
                    self.paymentRequest.hash = hash;
                    bolt.launch(self.paymentRequest, {
                        responseHandler: function (response) {
                            var payUResp = response.response;
                            self.subscriptionPayload.reqId = self.paymentRequest.reqId;
                            self.subscriptionPayload.status = payUResp.txnStatus;
                            self.subscriptionPayload.merchantTranId = self.hashPayload.txnid;
                            self.subscriptionPayload.subType = self.selectedProduct.description;
                            self.subscriptionPayload.scid = self.scid;

                            if (payUResp.txnStatus === "SUCCESS" && payUResp.txnid === self.paymentRequest.txnid) {
                                self.hashPayload.type = "response";
                                self.hashPayload.status = payUResp.status;
                                self.hashPayload.amount = payUResp.amount;
                                self.subscriptionPayload.modeOfPayment = payUResp.mode;
                                self.subscriptionPayload.transactionId = payUResp.payuMoneyId;
                                self.subscriptionPayload.amount = payUResp.amount;

                                self.generatepayuhash(self.hashPayload).then(hash => {
                                    if (hash === payUResp.hash) {
                                        //Successful Payment Processing
                                        self.subscriptionPayload.receipt = "Payment Success";
                                        self.subscriptionPayload.receiptType = "Payment Success";
                                        self.subscriptionPayload.receiptVerification = "Payment Success";

                                        self.processSubscription(self.subscriptionPayload, true);
                                    } else {
                                        //Failure Payment Processing
                                        self.subscriptionPayload.receipt = "Invalid Payment Response Hash";
                                        self.subscriptionPayload.receiptType = "Invalid Payment Response Hash";
                                        self.subscriptionPayload.receiptVerification = "Invalid Payment Response Hash";
                                        self.processSubscription(self.subscriptionPayload, false);
                                    }
                                });
                            } else if (payUResp.txnStatus === "FAILED" && payUResp.txnid === self.paymentRequest.txnid) {
                                //Failure Payment Processing
                                self.subscriptionPayload.modeOfPayment = payUResp.mode;
                                self.subscriptionPayload.transactionId = payUResp.payuMoneyId;
                                self.subscriptionPayload.amount = payUResp.amount;
                                self.subscriptionPayload.receipt = "Payment Failed";
                                self.subscriptionPayload.receiptType = "Payment Failed";
                                self.subscriptionPayload.receiptVerification = "Payment Failed";

                                self.processSubscription(self.subscriptionPayload, false);
                            } else if (payUResp.txnStatus === "CANCEL") {
                                //Cancelled Payment Processing
                                self.cancelPaymentReqPayload.reqId = self.paymentRequest.reqId;
                                self.cancelPaymentReqPayload.status = payUResp.txnStatus;
                                self.updatepaymentrequest(self.cancelPaymentReqPayload).then(data => {
                                    self.subscriptionPayload.receipt = "Payment Canceled";
                                    self.subscriptionPayload.receiptType = "Payment Canceled";
                                    self.subscriptionPayload.receiptVerification = "Payment Canceled";
                                    self.subscriptionPayload.amount = self.paymentRequest.amount;
                                    self.subscriptionPayload.transactionId = "N.A";
                                    self.subscriptionPayload.modeOfPayment = "N.A";

                                    self.$store.commit('SET_PAYMENT_PROCESS', self.subscriptionPayload);
                                    self.navToPaymentFailure();
                                });
                            }
                        },
                        catchException: function (error) {
                            self.$dialog.alert('Payment Failed, Please Try Again!');
                        }
                    });
                });
            });
        },

        async processSubscription (subPayload, issuccess) {
            var self = this;
            const data = await this.processpaymentrequest(subPayload);
            if (issuccess) {
                if (data.isInitialSubscription) {
                    var email = self.$store.state.authentication.user.email;
                    self.sendinitialsubscriptionmail(email);
                }
                const userId = self.$store.state.authentication.user.id;
                const prodductType = 'psi';
                const transactionId = subPayload.merchantTranId;
                const result = await this.setEsignData(userId, prodductType, transactionId);
                self.navToPaymentSuccess();
            } else {
                self.navToPaymentFailure();
            }
            
        },

        navToPaymentSuccess () {
            this.$router.push("/paymentsuccess/");
        },

        navToPaymentFailure () {
            this.$router.push("/paymentfailure/");
        },

        async checkauth () {
            if (localStorage.getItem('psitoken')) {
                this.checkCkycStatus ()
            }
        },

        async getCkycPopup() {
            let psitoken = localStorage.getItem('psitoken');
            if(psitoken){
                await this.getIsCkyc(psitoken).then((response) => {
                    if(response.user.isCKYC == 1){
                        let params = {
                        "user_email": localStorage.getItem('uemail')
                        }
                    this.checkuserckyc(params).then(data => {
                        if (subsdata == null) {
                            this.isCKYCDone = data.success
                        }
                        else {
                            if (!data.success) {
                                this.showKYCAlert = true
                            }
                            this.isCKYCDone = data.success
                        }
                    })
                    }
                })
            }else{
            }
        },

        async checkCkycStatus () {
            await this.getusersubscription().then(async subsdata => {
                if (subsdata != null) {
                    this.isPremiumUser = subsdata.remainingAccess > 0 ? true : false
                }
                // if (subsdata.remainingAccess > 0) {
                this.getCkycPopup()
                // }
            });
        },

        async checkCkycPaySecure () {
            let psitoken = localStorage.getItem('psitoken');
            let params = {
                "user_email": localStorage.getItem('uemail')
                }
            
            await this.getIsCkyc(psitoken).then((response) => {
                if(response.user.isCKYC == 1){
                    this.checkuserckyc(params).then(data => {
                        if (!data.success) {
                            const userId = this.$store.state.authentication.user.id
                            const emailId = this.$store.state.authentication.user.email
                            const safeUrl = encodeURIComponent(window.location.href);
                            const href = `https://ckycui-dot-qsi-gcloud-prod.el.r.appspot.com/ckycui/?uid=${userId}&prod=PSI&email=${emailId}&url=${safeUrl}`;
                            window.location.href = href;
                        }else{
                            this.proceedToPay ()
                        }
                    })
                } else {
                    this.proceedToPay ()
                }
            })
          },

          async proceedToPay (){
            var isUserInfoNotPresent = (!this.$store.state.authentication.user.email && this.$store.state.authentication.user.email != '') || (!this.$store.state.authentication.user.phoneNumber && this.$store.state.authentication.user.phoneNumber != '');
            var self = this
            if (this.riskInfo.state == null || this.riskInfo.state === 'null') {
                this.$notify({
                    group: 'allAlerts',
                    title: '',
                    type: 'warn',
                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-warn fa fa-exclamation-triangle" aria-hidden="true"></i></span> <span class="notificationText">Please Select State </span></div>'
                });
            }
            else if (isUserInfoNotPresent) {
                this.$notify({
                    group: 'allAlerts',
                    title: '',
                    type: 'warn',
                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-warn fa fa-exclamation-triangle" aria-hidden="true"></i></span> <span class="notificationText">Email or Phone Number is Missing! </span></div>'
                });
            }

            else {
                // self.saveRiskPorfiler();
                self.initiatePaymentRequest();


                
            }
          },

           initiatePaymentRequest () {
            if (this.isRazorPayActive) {
                this.initiateRazorpayPayment();
            }else {
                this.createPaymentRequest();
            }
        },


          validateGSTN(gstin) {
            var gstinRegex = new RegExp("[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}");
            if (gstin != null) {
                if (gstin.length == 15) {
                    if (gstin.trim() != '' && gstin != null ) {
                        if (gstinRegex.test(gstin.toUpperCase()) == true) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                else if (gstin.length > 15) {
                    return false
                }
                else if (gstin.length < 15 && gstin.length > 0) {
                    return false
                }
            }
          },

          async setEsignData(userId, productType, transactionId) {
            try {
                const payload = {
                    UserId: userId,
                    productType,
                    transactionId,
                };
                const response = await axios.post('https://esign-api-dot-qsi-gcloud-prod.el.r.appspot.com/esign/api/subscription/setEsignData.json', payload);
                const { success, id } = response.data.data;

                if (success) {
                    return { success: true, id };
                } else {
                    return { success: false, id: null };
                }
            } catch (error) {
                return { success: false, error: error.response?.data || error.message };
            }
        },

        async initiateRazorpayPayment () {
            var self = this;
            var user = this.$store.state.authentication.user;
            self.paymentReqPayload.productId = self.selectedProduct.id;
            self.paymentReqPayload.deviceId = 1;
            self.paymentReqPayload.amount = self.selectedProduct.finalAmount;
            self.paymentReqPayload.gatewayId = 1;
            self.paymentReqPayload.promoId = self.promoId != 0 ? self.promoId : '';
            self.paymentReqPayload.currency = self.rzpPymentRequest.currency

            self.rzpPymentRequest.amount = self.selectedProduct.finalAmount;
            self.rzpPymentRequest.name = user.name.split(' ')[0];
			self.rzpPymentRequest.prefill.name = user.name.split(' ')[0];
			self.rzpPymentRequest.prefill.email = user.email;
			self.rzpPymentRequest.prefill.contact = user.phoneNumber;

            await self.createrzppaymentrequest(self.paymentReqPayload).then(data => {
                
                self.rzpPymentRequest.notes.reqId = data.reqId;
				self.rzpPymentRequest.order_id = data.orderId;
				self.rzpPymentRequest.orderId = data.orderId;

                self.rzpPymentRequest.handler = function (response) {

                    //On Success create subscription payload modal
                    self.rzpSubscriptionPayload.reqId = self.rzpPymentRequest.notes.reqId;
					self.rzpSubscriptionPayload.orderId = response.razorpay_order_id;
					self.rzpSubscriptionPayload.paymentId = response.razorpay_payment_id;
					self.rzpSubscriptionPayload.signature = response.razorpay_signature;
					self.rzpSubscriptionPayload.transactionResponse = response;
					self.rzpSubscriptionPayload.amount = self.rzpPymentRequest.amount;
                    self.rzpSubscriptionPayload.subType = self.selectedProduct.description;
					self.rzpSubscriptionPayload.status = "SUCCESS";
                    self.processSubscription(self.rzpSubscriptionPayload, true);  //changes required from backend db  
                }

                //TO-DO: commented because it was giving error
                self.rzpPymentRequest.modal.ondismiss = function () {
                    self.cancelPaymentReqPayload.reqId = self.rzpPymentRequest.notes.reqId;
                    self.cancelPaymentReqPayload.status = "CANCEL";
                    self.updatepaymentrequest(self.cancelPaymentReqPayload).then(data => {
                    self.subscriptionPayload.receipt = "Payment Canceled";
                    self.subscriptionPayload.receiptType = "Payment Canceled";
                    self.subscriptionPayload.receiptVerification = "Payment Canceled";
                    self.subscriptionPayload.amount = self.paymentRequest.amount;
                    self.subscriptionPayload.transactionId = "N.A";
                    self.subscriptionPayload.modeOfPayment = "N.A";

                    self.$store.commit('SET_PAYMENT_PROCESS', self.subscriptionPayload);
                        self.navToPaymentFailure();
                    });
                };

                var rzp1 = new Razorpay(self.rzpPymentRequest);
                rzp1.open();    
    
                //for payment faliure 
                rzp1.on('payment.failed', function (response){    
                    self.rzpSubscriptionPayload.reqId = self.rzpPymentRequest.notes.reqId;
                    self.rzpSubscriptionPayload.orderId = response.error.metadata.order_id;
                    self.rzpSubscriptionPayload.paymentId = response.error.metadata.payment_id;
                    self.rzpSubscriptionPayload.transactionResponse = response;
                    self.rzpSubscriptionPayload.status = "FAILED";
    
                    self.processSubscription(self.rzpSubscriptionPayload, true);
    
                });
            }); 
        }


    }
}



// WEBPACK FOOTER //
// ./src/assets/js/plandetails.js